module.exports = __webpack_public_path__ + "static/media/lutherova.41958a61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/lutherova.jpg
// module id = 555
// module chunks = 0